<template>
	<div class="main-panel">
		<table height=100% width=100% cellpadding=0 cellspacing=0>
            <tr height="100%">
                <div class="inner-panel">
                    <el-tabs v-if="showTab" v-model="selectedTabName" type="border-card" @tab-click="reDrawTab">
                        <el-tab-pane :label="$t('message.item_tenant')" name="tenantInfo"></el-tab-pane>
                        <el-tab-pane v-if="enableCardInfo" :label="$t('message.item_tenant_creditCard')" name="creditCardInfo"></el-tab-pane>
                        <el-tab-pane :label="$t('message.item_tenant_notify_mail')" name="mailNotification"></el-tab-pane>
                        <el-tab-pane v-if="showRadioIntegrationTab" :label="$t('message.item_tenant_ip_radio')" name="ipRadioIntegration"></el-tab-pane>
                        <div v-if="selectedTabName=='tenantInfo'">
                            <table width="100%">
                                <tr class="account-record-header">
                                    <td class="account-item-title" width="20%" v-t="'message.item_tenant_company'"></td>
                                    <td class="account-item-title" width="20%" v-t="'message.item_tenant_department'"></td>
                                    <td class="account-item-title" width="10%" v-t="'message.item_tenant_contact'"></td>
                                    <td class="account-item-title" width="20%" v-t="'message.item_tenant_email'"></td>
                                    <td class="account-item-title" width="10%" v-t="'message.item_tenant_phone'"></td>
                                    <td class="account-item-title" width="20%">
                                        <div class="account-command">
                                            <div class="account-command-left" v-t="'message.item_tenant_address'"></div>
                                            <div class="account-command-right">
                                                <button class="transparent-button" type="button" v-on:click="showEditOwnerAccountDialog()"><img src="../assets/edit.svg"/><span class="normal-command-text" v-t="'message.common_action_edit'"></span></button>
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                                <tr v-if="tenant != null" class="account-record-bottom">
                                    <td class="account-item-value">{{ tenant.displayName }}</td>
                                    <td class="account-item-value">{{ tenant.departmentName }}</td>
                                    <td class="account-item-value">{{ tenant.primaryOwnerName }}</td>
                                    <td class="account-item-value">{{ tenant.primaryOwner }}</td>
                                    <td class="account-item-value">{{ tenant.phoneNumber }}</td>
                                    <td class="account-item-value">{{ tenant.zip + " " + tenant.addressPref + tenant.addressCity + tenant.addressTown + tenant.addressStreet }}</td>
                                </tr>
                            </table>
                        </div>
                        <div v-if="selectedTabName=='creditCardInfo'">
                            <table width="100%">
                                <tr class="account-record-header">
                                    <td class="account-item-title" v-t="'message.item_tenant_cardType'"></td>
                                    <td class="account-item-title" v-t="'message.item_card_number'"></td>
                                    <td class="account-item-title" v-t="'message.item_card_expire'"></td>
                                    <td class="account-item-title">
                                        <div class="account-command">
                                            <div class="account-command-left" v-t="'message.item_card_holder'"></div>
                                            <div class="account-command-right">
                                                <div v-if="creditCard != null">
                                                    <button class="transparent-button" type="button" v-on:click="showEditCreditCardDialog()"><img src="../assets/edit.svg"/><span class="normal-command-text" v-t="'message.common_action_edit'"></span></button>
                                                </div>
                                                <div v-else>
                                                    <button class="transparent-button" type="button" v-on:click="showEditCreditCardDialog()"><img src="../assets/edit.svg"/><span class="normal-command-text" v-t="'message.common_action_add'"></span></button>
                                                </div>
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                                <tr v-if="creditCard != null" class="account-record">
                                    <td class="account-item-value">{{ creditCard.cardName }}</td>
                                    <td class="account-item-value">{{ creditCard.cardNo }}</td>
                                    <td class="account-item-value">{{ creditCard.expireDate }}</td>
                                    <td class="account-item-value">{{ creditCard.holderName }}</td>
                                </tr>
                                <tr v-else class="account-record">
                                    <td colspna="4" class="account-item-value" v-t="'message.info_no_creditCard_information'"></td>
                                </tr>
                            </table>
                        </div>
                        <div v-if="selectedTabName=='mailNotification'">
                            <table width="100%">
                                <tr class="account-record-header">
                                    <td class="account-item-title" v-t="'message.item_tenant_email'"></td>
                                    <td class="account-item-title" v-t="'message.item_contact_name'"></td>
                                    <td class="account-item-title">
                                        <span v-t="'message.item_notify_admin'"></span>
                                        <el-tooltip effect="dark" placement="top-start" >
                                            <div slot="content" style="text-align:left" v-t="'message.hint_notify_mail_admin'"></div>
                                            <img class="icon-help" :src="require('@/assets/icon_help.svg')"/>
                                        </el-tooltip>
                                    </td>
                                    <td class="account-item-title">
                                        <span v-t="'message.item_notify_contract'"></span>
                                        <el-tooltip effect="dark" placement="top-start" >
                                            <div slot="content" style="text-align:left" v-t="'message.hint_notify_mail_contract'"></div>
                                            <img class="icon-help" :src="require('@/assets/icon_help.svg')"/>
                                        </el-tooltip>
                                    </td>
                                    <td class="account-item-title">
                                        <span v-t="'message.item_notify_maintenance'"></span>
                                        <el-tooltip effect="dark" placement="top-start" >
                                            <div slot="content" style="text-align:left" v-t="'message.hint_notify_mail_system'"></div>
                                            <img class="icon-help" :src="require('@/assets/icon_help.svg')"/>
                                        </el-tooltip>
                                    </td>
                                    <td class="account-item-title">
                                        <span v-t="'message.item_notify_service_failure'"></span>
                                        <el-tooltip effect="dark" placement="top-start" >
                                            <div slot="content" style="text-align:left" v-t="'message.hint_notify_mail_failure'"></div>
                                            <img class="icon-help" :src="require('@/assets/icon_help.svg')"/>
                                        </el-tooltip>
                                    </td>
                                    <td class="account-item-title" style="text-align:right;padding-right:20px">
                                        <button class="transparent-button" type="button" v-on:click="showAddMailDestinationDialog()"><img src="../assets/add_user.svg"/><span class="normal-command-text" v-t="'message.common_action_add'"></span></button>
                                    </td>
                                </tr>
                                <tr v-for="(mailDestinationInfo, index) in mailDestinationList"
                                    :class="{'account-record':((index < mailDestinationList.length-1) && (index > 0)),'account-record-bottom':((index == mailDestinationList.length-1) && (index > 0)), 'account-record-no-hover':((index < mailDestinationList.length-1) && (index == 0)),'account-record-no-hover-bottom':((index == mailDestinationList.length-1) && (index == 0))}">
                                    <td :class="{'account-item-value': (!mailDestinationInfo.primaryOwner),'account-item-no-update': (mailDestinationInfo.primaryOwner)}">{{ mailDestinationInfo.email }}</td>
                                    <td :class="{'account-item-value': (!mailDestinationInfo.primaryOwner),'account-item-no-update': (mailDestinationInfo.primaryOwner)}">{{ mailDestinationInfo.userName }}</td>
                                    <td v-if="mailDestinationInfo.primaryOwner" class="account-item-no-update">{{ getNotificationStatus(true) }}</td>
                                    <td v-else class="account-item-value">-</td>
                                    <td :class="{'account-item-value': (!mailDestinationInfo.primaryOwner),'account-item-no-update': (mailDestinationInfo.primaryOwner)}">{{ getNotificationStatus(mailDestinationInfo.notifyContract) }}</td>
                                    <td :class="{'account-item-value': (!mailDestinationInfo.primaryOwner),'account-item-no-update': (mailDestinationInfo.primaryOwner)}">{{ getNotificationStatus(mailDestinationInfo.notifySystem) }}</td>
                                    <td :class="{'account-item-value': (!mailDestinationInfo.primaryOwner),'account-item-no-update': (mailDestinationInfo.primaryOwner)}">{{ getNotificationStatus(mailDestinationInfo.notifyServiceFailure) }}</td>
                                    <td class="account-item-value" style="text-align:right;padding-right:20px">
                                        <span v-if="!mailDestinationInfo.primaryOwner">
                                            <button class="transparent-button" type="button" v-on:click="showEditMailDestinationDialog(mailDestinationInfo)"><img src="../assets/edit.svg"/></button>
                                            <button class="transparent-button" type="button" v-on:click="showDeleteMailDestinationDialog(mailDestinationInfo)"><img src="../assets/icon_delete_user.svg"/></button>
                                        </span>
                                    </td>
                                </tr>
                            </table>
                        </div>
                        <div v-if="selectedTabName=='ipRadioIntegration'">
                            <table width="100%">
                                <tr class="account-record-header">
                                    <td class="account-item-title" width="80%">
                                        <div class="account-command">
                                            <div class="account-command-right">
                                                <button class="transparent-button" type="button" v-if="ipRadioIntegrationStatus === '連携していません'" v-on:click="issueToken()">
                                                    <img src="../assets/icon_lock.svg"/>
                                                    <span class="normal-command-text" v-t="'message.action_issue_token'"></span>
                                                </button>
                                                <button class="transparent-button" type="button" v-if="ipRadioIntegrationStatus === 'トークン発行中'" v-on:click="invalidateToken()">
                                                    <img src="../assets/icon_delete_tag.svg"/>
                                                    <span class="normal-command-text" v-t="'message.action_invalidate_token'"></span>
                                                </button>
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                                <tr class="account-record-bottom">
                                    <td class="account-item-title" width="80%">
                                        <div class="account-command">
                                            <div class="account-command-left">
                                                <span>連携情報</span>
                                            </div>
                                            <div class="account-command-right">
                                                <div v-if="ipRadioIntegrationStatus === '連携中'" class="status-icon"></div>
                                                <span :style="{ color: ipRadioIntegrationStatus === '連携していません' ? '#ccc' : ipRadioIntegrationStatus === '連携中' ? '#9acd32' : '' }">{{ ipRadioIntegrationStatus }}</span>
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                                <tr v-if="ipRadioIntegrationStatus === '連携中'" class="account-record-bottom">
                                    <td class="account-item-title" width="80%">
                                        <div class="account-command">
                                            <div class="account-command-left">
                                                <span>{{getMessageText('item_radio_permission_for_non_radio_admin')}}</span>
                                            </div>
                                            <div class="account-command-right">
                                                <span :style="{ color: isRadioAdminPermissionGranted ? '#9acd32' : '#ccc' }">{{ isRadioAdminPermissionGranted ? getMessageText('item_permission_granted') : getMessageText('item_permission_not_granted') }}</span>
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                                <tr v-if="ipRadioIntegrationStatus === '連携中'" class="account-record-bottom">
                                    <td class="account-item-title" width="80%">
                                        <div class="account-command">
                                            <div class="account-command-left">
                                                <span>無線機管理ユーザー</span>
                                            </div>
                                            <div class="account-command-right">
                                                <span v-if="radioManager !== null">
                                                    <span> {{ radioManager.userId }} / {{ radioManager.displayName }} </span>
                                                </span>
                                                <span v-else>なし</span>
                                                <button class="transparent-button" type="button" v-on:click="showEditRadioManagerPermissionDialog=true" style="margin-left: 10px;">
                                                    <img src="../assets/edit.svg"/>
                                                    <span class="normal-command-text">編集</span>
                                                </button>
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                            </table>
                        </div>
                    </el-tabs>
                </div>
            </tr>
        </table>
        <editowneraccountinfo v-if="showEditOwnerAccount" :tenant="tenant" @save="saveAccountInfo" @cancel="showEditOwnerAccount=false"></editowneraccountinfo>
        <editcreditcardinfo v-if="showEditCreditCard" :appData="appData" :tenant="tenant" :creditCard="creditCard" @save="saveCreditCardInfo" @cancel="showEditCreditCard=false"></editcreditcardinfo>
        <AddMailDestination v-if="showAddMailDestination" :primaryOwner="appData.tenantList[0].primaryOwner" @add="addTenantMailDestinationInfo" @cancel="showAddMailDestination=false"></AddMailDestination>
        <EditMailDestination v-if="showEditMailDestination" :notificationMailInfo="selectedMailDestinationInfo" @update="modifyTenantMailDestinationInfo" @cancel="showEditMailDestination=false"></EditMailDestination>
        <DeleteMailDestination v-if="showDeleteMailDestination" :confirmInfo="confirmInfo" @delete="deleteTenantMailDestinationInfo" @cancel="showDeleteMailDestination=false"></DeleteMailDestination>
        <IssueTokenDialog
            v-if="showIssueTokenDialog"
            :tenantId="appData.tenantList[0].tenantId"
            :appData="appData"
            @issued="handleTokenIssued"
            @cancel="showIssueTokenDialog=false"/>
        <EditRadioManagerPermissionDialog
            v-if="showEditRadioManagerPermissionDialog"
            :tenantName="appData.tenantList[0].name"
            :currentPermissions="radioManagerPermissions"
            @save="handlePermissionSave"
            @cancel="showEditRadioManagerPermissionDialog=false"/>
	</div>
</template>

<script>
import Vue from 'vue'
import server from "./ServerApi.js";
import commonUtil from './commonutil.js';
import constants from './constants.js';
import EditOwnerAccountInfo from './EditOwnerAccountInfo.vue';
import EditCreditCardInfo from './EditCreditCardInfo.vue';
import AddMailDestination from './AddMailDestination.vue';
import EditMailDestination from './EditMailDestination.vue';
import DeleteObject from "./DeleteObject.vue";
import IssueTokenDialog from './IssueTokenDialog.vue';
import EditRadioManagerPermissionDialog from './EditRadioManagerPermissionDialog.vue';

export default {
    data () {
        return {
            tenant: null,
            creditCard: null,
            mailDestinationList: null,
            basicContract: null,
            visibleAccountInfo: true,
            visibleCardInfo: false,
            enableCardInfo: false,
            showEditOwnerAccount: false,
            showEditCreditCard: false,
            showAddMailDestination: false,
            showEditMailDestination: false,
            showDeleteMailDestination: false,
            showIssueTokenDialog: false,
            managementUserRights: false,
            selectedTabName: "tenantInfo",
            selectedMailDestinationInfo: null,
            showTab: true,
            confirmInfo: {
                objectName: null,
                objectTitle: null
            },
            ipRadioIntegrationStatus: "連携していません",
            isRadioAdminPermissionGranted: false,
            radioManager: null,
            radioManagerPermissions: {
                consoleManagementTracking: false,
                consoleManagementEditUserAndTalkGroupDefinition: false,
                consoleManagementEditUserTalkGroupAssignment: false,
                consoleManagementTenantManagement: false
            },
            showEditRadioManagerPermissionDialog: false,
        };
    },

    computed: {
        showRadioIntegrationTab() {
            return commonUtil.isRadioAvailablePlan(this.appData) && this.appData.tenantAdminUser;
        },
    },

    methods: {
        getMessageText(messageId) {
            return commonUtil.getMessageText(this.$i18n, messageId);
        },
        getTenantInfo() {
            let self = this;
            server.post('/gettenants')
                .then((res) => {
                    if (res.data.status == constants.STATUS_SUCCESS) {
                        self.tenant = res.data.tenants[0];
                        this.getBasicContract(self.tenant.tenantId);
                    } else {
                        commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_server_api").replace("{functionName}","getTenantInfo").replace("{code}",res.data.status) );
                    }
                })
                .catch( function ( error ) {
                    commonUtil.putExceptionErrorMessage(self, "getTenantInfo", error);
                });
        },
        getBasicContract(tenantId) {
            let self = this;
            server.post('/getbasiccontract', { tenantId: tenantId} )
                .then((res) => {
                    if (res.data.status == constants.STATUS_SUCCESS) {
                        self.basicContract = res.data;
                        if ((self.basicContract.purchasePeriodType != 99) &
                            (self.basicContract.billingType == 1)) {
                            self.enableCardInfo = true;
                            self.getCreditCardInfo();
                        }
                    } else {
                        switch(res.data.status) {
                            case constants.STATUS_ERROR_DENIED:
                                commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_access_denied"));
                                break;
                            default:
                                commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_server_api").replace("{functionName}","getIgetBasicContractnfo").replace("{code}",res.data.status) );
                                break;
                        }
                    }
                })
                .catch( function ( error ) {
                    commonUtil.putExceptionErrorMessage(self, "getBasicContract", error);
                });
        },
        getUserRights() {
            let self = this;
            let loginId =  this.appData.loginId.split("@");
            server.post('/getinfo',{tenantId: this.appData.tenantList[0].tenantId, name: loginId[0], type: 1, userTalkgroupInfo: false }
            ).then((res) => {
                switch (res.data.status) {
                    case constants.STATUS_SUCCESS:
                        self.managementUserRights = commonUtil.checkUserPrivilege(res.data.rights, constants.PRIVILEGE_TENANT_ADMIN);
                        break;
                    case constants.STATUS_ERROR_DENIED:
                        commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(this.$i18n,"error_cannot_confirm_rights_by_denied"));
                        break;
                    default:
                        commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_server_api").replace("{functionName}","getUserRights").replace("{code}",res.data.status));
                        break;
                }
            })
            .catch( function ( error ) {
                commonUtil.putExceptionErrorMessage(self, "getUserRights", error);
            });
        },
        getTenantMailDestinationInfo() {
            let self = this;
            self.mailDestinationList = [];
            server.post('/gettenantmaildestination')
            .then((res) => {
                switch(res.data.status) {
                    case constants.STATUS_SUCCESS:
                        for (let mailDestinationInfo of res.data.tenantMailDestinationInfoList) {
                            if (mailDestinationInfo.email == self.appData.tenantList[0].primaryOwner) {
                                mailDestinationInfo.userName = mailDestinationInfo.userName + " (" + commonUtil.getMessageText(self.$i18n,"item_tenant_admin") + ")";
                                mailDestinationInfo.primaryOwner = true;
                                self.mailDestinationList.unshift(mailDestinationInfo);
                            } else {
                                mailDestinationInfo.primaryOwner = false;
                                self.mailDestinationList.push(mailDestinationInfo);
                            }
                        }
                        break;
                    case constants.STATUS_ERROR_NOT_FOUND:
                        break;
                    default:
                        commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_server_api").replace("{functionName}","getTenantMailDestinationInfo").replace("{code}",res.data.status) );
                        break;
                }
            })
            .catch( function ( error ) {
                commonUtil.putExceptionErrorMessage(self, "getTenantMailDestinationInfo", error);
            });
        },
        displayAccountInfo() {
            this.visibleAccountInfo = true;
            this.visibleCardInfo = false;
        },
        displayCardInfo() {
            this.visibleAccountInfo = false;
            this.visibleCardInfo = true;
        },
        getCreditCardInfo() {
            let self = this;
            server.post('/gmopaymentsearchcard'
            ).then((res) => {
                switch (res.data.status) {
                    case constants.STATUS_SUCCESS:
                        self.creditCard = {cardName: res.data.cardName ,
                                    cardNo: res.data.cardNo ,
                                    expireDate: "20" + res.data.expireYear + "/" + res.data.expireMonth ,
                                    holderName: res.data.holderName
                                    };
                        let currentDate = new Date();
                        let cardExpired = false;
                        if (res.data.expireYear < (currentDate.getFullYear() - 2000)) {
                            cardExpired = true;
                        }
                        if (res.data.expireYear == (currentDate.getFullYear() - 2000)) {
                            if (res.data.expireMonth < (currentDate.getMonth() + 1)) {
                                cardExpired = true;
                            }
                        }
                        if (cardExpired) {
                            commonUtil.notifyMessage(self,"Warning",commonUtil.getMessageText(this.$i18n,"error_creditCard_expired"));
                        }
                        break;
                    case constants.STATUS_ERROR_EXTERNAL_SYSTEM:
                        self.creditCard = null;
                        if (res.data.errorInfo.includes("E01240002")) {
                            commonUtil.notifyMessage(self,"Warning",commonUtil.getMessageText(this.$i18n,"error_creditCard_not_registered"));
                        } else {
                            commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(this.$i18n,"error_creditCard_not_found"));
                        }
                        break;
                    default:
                        self.creditCard = null;
                        commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_server_api").replace("{functionName}","getCreditCardInfo").replace("{code}",res.data.status));
                        break;
                }
                self.reDrawTab();
            })
            .catch( function ( error ) {
                self.creditCard = null;
                commonUtil.putExceptionErrorMessage(self, "getCreditCardInfo", error);
            });
        },
        getNotificationStatus(status) {
            if (status) {
                return commonUtil.getMessageText(this.$i18n,"value_present");
            } else {
                return commonUtil.getMessageText(this.$i18n,"value_absent");
            }
        },
        showEditOwnerAccountDialog() {
            if (this.managementUserRights) {
                this.showEditOwnerAccount = true;
            } else {
                commonUtil.notifyMessage(this,"Warning",commonUtil.getMessageText(this.$i18n,"error_cannot_modify_account_information"));
            }
        },
        issueToken() {
            this.showIssueTokenDialog = true;
        },
        handleTokenIssued() {
            this.showIssueTokenDialog = false;
            // Refresh the integration status after token issuance
            this.getIpRadioIntegrationStatus();
        },
        addTenantMailDestinationInfo(input) {
            this.showAddMailDestination = false;
            let self = this;
            let param = {
                email: input.email,
                userName: input.displayName,
                notifyContract: input.notifyContract,
                notifySystem: input.notifySystem,
                notifyServiceFailure: input.notifyServiceFailure
            };
            server.post('/addtenantmaildestination', param )
            .then((res) => {
                switch(res.data.status) {
                    case constants.STATUS_SUCCESS:
                        commonUtil.notifyMessage(self,"Success",commonUtil.getMessageText(self.$i18n,"info_modified_account_information"));
                        self.getTenantMailDestinationInfo();
                        break;
                    case constants.STATUS_ERROR_ALREADY_EXISTED:
                        commonUtil.notifyMessage(self,"Warning",commonUtil.getMessageText(self.$i18n,"error_notify_mail_exist"));
                        break;
                    default:
                        commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_server_api").replace("{functionName}","addTenantMailDestination").replace("{code}",res.data.status) );
                        break;
                }
            })
            .catch( function ( error ) {
                commonUtil.putExceptionErrorMessage(self, "addTenantMailDestination", error);
            });
        },
        modifyTenantMailDestinationInfo(input) {
            this.showEditMailDestination = false;
            let self = this;
            let param = {
                email: this.selectedMailDestinationInfo.email,
                newEmail: input.email,
                newUserName: input.displayName,
                newNotifyContract: input.notifyContract,
                newNotifySystem: input.notifySystem,
                newNotifyServiceFailure: input.notifyServiceFailure
            };
            server.post('/modifytenantmaildestination', param )
            .then((res) => {
                switch(res.data.status) {
                    case constants.STATUS_SUCCESS:
                        commonUtil.notifyMessage(self,"Success",commonUtil.getMessageText(self.$i18n,"info_modified_account_information"));
                        self.getTenantMailDestinationInfo();
                        break;
                    case constants.STATUS_ERROR_ALREADY_EXISTED:
                        commonUtil.notifyMessage(self,"Warning",commonUtil.getMessageText(self.$i18n,"error_notify_mail_exist"));
                        break;
                    default:
                        commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_server_api").replace("{functionName}","modifyTenantMailDestination").replace("{code}",res.data.status) );
                        break;
                }
            })
            .catch( function ( error ) {
                commonUtil.putExceptionErrorMessage(self, "modifyTenantMailDestination", error);
            });
        },
        deleteTenantMailDestinationInfo(input) {
            this.showDeleteMailDestination = false;
            let self = this;
            let param = {
                email: this.selectedMailDestinationInfo.email,
            };
            server.post('/deletetenantmaildestination', param )
            .then((res) => {
                switch(res.data.status) {
                    case constants.STATUS_SUCCESS:
                        commonUtil.notifyMessage(self,"Success",commonUtil.getMessageText(self.$i18n,"info_modified_account_information"));
                        self.getTenantMailDestinationInfo();
                        break;
                    default:
                        commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_server_api").replace("{functionName}","deleteTenantMailDestination").replace("{code}",res.data.status) );
                        break;
                }
            })
            .catch( function ( error ) {
                commonUtil.putExceptionErrorMessage(self, "deleteTenantMailDestination", error);
            });
        },
        saveAccountInfo(input) {
            let self = this;
            this.showEditOwnerAccount = false;
            let updateParam = {};
            if (input.corporateName.value != this.tenant.displayName) {
                updateParam.newDisplayName = input.corporateName.value;
            }
            if (input.departmentName.value != this.tenant.departmentName) {
                updateParam.newDepartmentName = input.departmentName.value;
            }
            if (input.primaryOwnerName.value != this.tenant.primaryOwnerName) {
                updateParam.newPrimaryOwnerName = input.primaryOwnerName.value;
            }
            if (input.primaryOwnerEmail.value != this.tenant.primaryOwner) {
                updateParam.newPrimaryOwnerEmail = input.primaryOwnerEmail.value;
            }
            if (input.phoneNumber.value != this.tenant.phoneNumber) {
                updateParam.newPhoneNumber = input.phoneNumber.value;
            }
            if (input.zip.value !=this.tenant.zip) {
                updateParam.newZip = input.zip.value;
            }
            if (input.pref.value !=this.tenant.addressPref) {
                updateParam.newAddressPref = input.pref.value;
            }
            if (input.city.value !=this.tenant.addressCity) {
                updateParam.newAddressCity = input.city.value;
            }
            if (input.town.value !=this.tenant.addressTown) {
                updateParam.newAddressTown = input.town.value;
            }
            if (input.street.value !=this.tenant.addressStreet) {
                updateParam.newAddressStreet = input.street.value;
            }
            if (Object.keys(updateParam).length == 0) {
                commonUtil.notifyMessage(self,"Info",commonUtil.getMessageText(self.$i18n,"info_no_change_information"));
                return;
            }
            server.post('/modifytenantaccountinfo', updateParam )
                .then((res) => {
                    if (res.data.status == constants.STATUS_SUCCESS) {
                        commonUtil.notifyMessage(self,"Success",commonUtil.getMessageText(self.$i18n,"info_modified_account_information"));
                        self.getTenantInfo();
                    } else {
                        commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_server_api").replace("{functionName}","saveAccountInfo").replace("{code}",res.data.status) );
                    }
                })
                .catch( function ( error ) {
                    commonUtil.putExceptionErrorMessage(self, "saveAccountInfo", error);
                });
        },
        showEditCreditCardDialog() {
            if (this.managementUserRights) {
                this.showEditCreditCard = true;
            } else {
                commonUtil.notifyMessage(this,"Warning",commonUtil.getMessageText(this.$i18n,"error_cannot_modify_account_information"));
            }
        },
        showAddMailDestinationDialog() {
            if (this.managementUserRights) {
                if (this.mailDestinationList.length >= constants.LIMIT_MAIL_ADDRESS) {
                    commonUtil.notifyMessage(this,"Warning",commonUtil.getMessageText(this.$i18n,"error_cannot_add_destination_email").replace("{limit_mail_address}", constants.LIMIT_MAIL_ADDRESS));
                    return;
                }
                this.showAddMailDestination = true;
            } else {
                commonUtil.notifyMessage(this,"Warning",commonUtil.getMessageText(this.$i18n,"error_cannot_modify_account_information"));
            }
        },
        showEditMailDestinationDialog(mailDestinationInfo) {
            if (this.managementUserRights) {
                this.selectedMailDestinationInfo = mailDestinationInfo;
                this.showEditMailDestination = true;
            } else {
                commonUtil.notifyMessage(this,"Warning",commonUtil.getMessageText(this.$i18n,"error_cannot_modify_account_information"));
            }
        },
        showDeleteMailDestinationDialog(mailDestinationInfo) {
            if (this.managementUserRights) {
                this.selectedMailDestinationInfo = mailDestinationInfo;
                this.confirmInfo.objectTitle = commonUtil.getMessageText(this.$i18n,"item_tenant_notify_mail");
                this.confirmInfo.objectName = mailDestinationInfo.email;
                this.showDeleteMailDestination = true;
            } else {
                commonUtil.notifyMessage(this,"Warning",commonUtil.getMessageText(this.$i18n,"error_cannot_modify_account_information"));
            }
        },
        saveCreditCardInfo() {
            this.showEditCreditCard = false;
            commonUtil.notifyMessage(this,"Success",commonUtil.getMessageText(this.$i18n,"info_creditCard_registered"));
            this.getCreditCardInfo();
        },
        reDrawTab() {
            // some of message of old tab was remained in new tab.
            // it can clear by redraw
            this.showTab = false;
            this.$nextTick(() => {
                 this.showTab = true
            })

            // Call IP Radio Integration Status API when ipRadioIntegration tab is selected
            if (this.selectedTabName === "ipRadioIntegration") {
                this.getIpRadioIntegrationStatus();
            }
        },
        getIpRadioIntegrationStatus() {
            let self = this;
            if (this.appData.tenantList.length > 0) {
                server.post('/getipradiointegrationstatus', { tenantId: this.appData.tenantList[0].tenantId })
                    .then((res) => {
                        if (res.data.status === constants.STATUS_SUCCESS) {
                            // Map API response to Japanese display text
                            switch (res.data.integrationStatus) {
                                case "Integrating":
                                    self.ipRadioIntegrationStatus = "連携中";
                                    break;
                                case "Issuing":
                                    self.ipRadioIntegrationStatus = "トークン発行中";
                                    break;
                                case "Not integrating":
                                    self.ipRadioIntegrationStatus = "連携していません";
                                    break;
                                default:
                                    self.ipRadioIntegrationStatus = "ステータス取得エラー";
                                    break;
                            }
                            // Store permission status and dealer users
                            self.isRadioAdminPermissionGranted = res.data.isRadioAdminPermissionGranted || false;
                            self.radioManager = res.data.radioManager || null;

                            // Store dealer permissions
                            if (res.data.radioManagerPermissions) {
                                self.radioManagerPermissions.consoleManagementTracking = res.data.radioManagerPermissions.consoleManagementTracking || false;
                                self.radioManagerPermissions.consoleManagementEditUserAndTalkGroupDefinition = res.data.radioManagerPermissions.consoleManagementEditUserAndTalkGroupDefinition || false;
                                self.radioManagerPermissions.consoleManagementEditUserTalkGroupAssignment = res.data.radioManagerPermissions.consoleManagementEditUserTalkGroupAssignment || false;
                                self.radioManagerPermissions.consoleManagementTenantManagement = res.data.radioManagerPermissions.consoleManagementTenantManagement || false;
                            }
                        } else {
                            self.ipRadioIntegrationStatus = "ステータス取得エラー";
                            commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_server_api").replace("{functionName}","getIpRadioIntegrationStatus").replace("{code}",res.data.status) );
                        }
                    })
                    .catch( function ( error ) {
                        self.ipRadioIntegrationStatus = "ステータス取得エラー";
                        commonUtil.putExceptionErrorMessage(self, "getIpRadioIntegrationStatus", error);
                    });
            }
        },
        invalidateToken() {
            let self = this;
            let requestData = {
                tenantId: this.appData.tenantList[0].tenantId,
            };

            server.post('/invalidateipradiointegrationtoken', requestData)
                .then((res) => {
                    if (res.data.status === constants.STATUS_SUCCESS) {
                        commonUtil.notifyMessage(self, "Success", commonUtil.getMessageText(self.$i18n, "msg_token_invalidated"));
                        // トークン無効化後にステータスを更新
                        self.getIpRadioIntegrationStatus();
                    } else if (res.data.status === constants.STATUS_ERROR_NOT_FOUND) {
                        commonUtil.notifyMessage(self, "Warning", commonUtil.getMessageText(self.$i18n, "msg_token_not_found"));
                    } else {
                        commonUtil.notifyMessage(self, "Error", commonUtil.getMessageText(self.$i18n, "error_server_api").replace("{functionName}", "invalidateToken").replace("{code}", res.data.status));
                    }
                })
                .catch(function(error) {
                    commonUtil.putExceptionErrorMessage(self, "invalidateToken", error);
                });
        },
        async handlePermissionSave(permission) {
            this.showEditRadioManagerPermissionDialog = false;

            let requestData = {
                canCreateUserAndGroup: permission.consoleManagementEditUserAndTalkGroupDefinition,
                canAddUserToGroup: permission.consoleManagementEditUserTalkGroupAssignment,
                canViewTracking: permission.consoleManagementTracking,
                canManageTenant: permission.consoleManagementTenantManagement,
            };

            try {
                let res = await server.post('/updateradioadminpermission', requestData)
                if (res.data.status === constants.STATUS_SUCCESS) {
                    commonUtil.notifyMessage(this, "Success", "権限が更新されました");
                } else if (res.data.status === constants.STATUS_ERROR_RADIO_MANAGER_IS_C2C_ADMIN) {
                    commonUtil.notifyMessage(this, "Warning", commonUtil.getMessageText(this.$i18n, "error_cannot_revoke_rights_by_linkAdmin"));
                } else {
                    commonUtil.notifyMessage(this, "Error", commonUtil.getMessageText(this.$i18n, "error_server_api").replace("{functionName}", "updateradioadminpermission").replace("{code}", res.data.status));
                }
            } catch (error) {
                commonUtil.putExceptionErrorMessage(this, "updateradioadminpermission", error);
            }

            this.getIpRadioIntegrationStatus();
        },
    },
    created: function() {
        if (this.appData.tenantList.length > 0) {
            this.tenant = this.appData.tenantList[0];
            this.getUserRights();
            this.getBasicContract();
            this.getTenantMailDestinationInfo();
        }
    },
    mounted: function() {
    },
    watch: {
        'appData.tenantList'(newVal) {
            this.tenant = this.appData.tenantList[0];
            this.getUserRights();
            this.getBasicContract();
            this.getTenantMailDestinationInfo();
        }
    },
    components: {
        editowneraccountinfo: EditOwnerAccountInfo,
        editcreditcardinfo: EditCreditCardInfo,
        AddMailDestination,
        EditMailDestination,
        DeleteMailDestination: DeleteObject,
        IssueTokenDialog,
        EditRadioManagerPermissionDialog,
    },
    props: ['appData']
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.license-title-box {
    width: 100%;
    background-color: #f6f6f6;
    display: table;
    border-bottom: 1px #fff solid;
}
.license-title-box-left {
    padding: 10px 0 10px 28px;
    width: 50%;
    display: table-cell;
    color: #848991;
    font-size: 12px;
    vertical-align: middle;
}
.license-title-box-right {
    padding: 10px 28px 10px 28px;
    position: relative;
    width: 50%;
    display: table-cell;
    text-align : right;
    vertical-align: middle;
    font-size: 12px;
}

.account-record {
    width: 100%;
    border-bottom:1px #eee solid;
}
.account-record-no-hover {
    width: 100%;
    border-bottom:1px #eee solid;
}
.account-record:hover
{
    background-color: #ecf1fa;
}
.account-record-bottom {
    width: 100%;
    border-bottom:none;
}
.account-record-bottom-no-hover {
    width: 100%;
    border-bottom:none;
}
.account-record-bottom:hover
{
    background-color: #ecf1fa;
}
.account-record-header {
    width: 100%;
    background-color: #f6f6f6;
    padding-top: 10px;
    padding-bottom: 10px;
    padding-left: 20px;
    font-size: 12px;
}
.account-item-title {
    padding-top: 10px;
    padding-bottom: 10px;
    padding-left: 20px;
    font-size: 12px;
}
.account-item-no-update {
    padding-top: 10px;
    padding-bottom: 10px;
    padding-left: 20px;
    font-size: 14px;
    color: #848991;
}
.account-item-value {
    padding-top: 10px;
    padding-bottom: 10px;
    padding-left: 20px;
    font-size: 14px;
    color: #333b38;
}

.account-command {
  position: relative;
  text-align : right;
  vertical-align: middle;
}
.account-command-left {
  color: #848991;
  font-size: 12px;
  vertical-align: middle;
  float: left;
}
.account-command-right {
  padding-right: 20px;
  position: relative;
  text-align : right;
  vertical-align: middle;
}
.account-command img {
  display: inline;
  vertical-align: middle;
  height: 18px;
  padding-right: 4px;
}

.el-tabs--border-card {
    box-shadow: none !important;
}
.el-tabs--border-card >>> .el-tabs__header .el-tabs__item:not(.is-disabled):hover {
    color: #5171cb;
    opacity: 0.7;
}
.el-tabs--border-card >>> .el-tabs__header .el-tabs__item.is-active {
    color: #848991;
    background: #f6f6f6;
    border: none;
}
.el-tabs--border-card >>> .el-tabs__header .el-tabs__item {
    color: #5171cb;
    background: #ecf1fa;
}
.el-tabs__nav-scroll {
    background: #ecf1fa;
}
.el-tabs--border-card >>> .el-tabs__header {
    border: none;
    background: #ecf1fa;
}
.el-tabs--border-card >>> .el-tabs__content {
    padding: 0px;
}
.el-tabs--border-card {
    border: none;
}

.bluetext {
    color: #5171cb;
}

.status-icon{
    display: inline-block;      /* ←これが重要 */
    width: 20px;
    height: 20px;
    margin-right: 8px;
    vertical-align: middle;

    background-color: #9acd32;

    -webkit-mask: url('../assets/icon_mutual.svg') no-repeat center;
    mask: url('../assets/icon_mutual.svg') no-repeat center;
    -webkit-mask-size: contain;
    mask-size: contain;
}

.link-button {
    background: none;
    border: none;
    color: #5171cb;
    text-decoration: underline;
    cursor: pointer;
    font-size: 14px;
    margin-left: 10px;
    padding: 0;
}

.link-button:hover {
    color: #3d5aa3;
    text-decoration: none;
}
</style>
